import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.linkedin.com/in/shubhamprajapati7748/"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-linkedin-alt"></i>
      </a>
      <a
        href="https://github.com/shubhamprajapati7748/"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-github-alt"></i>
      </a>

      <a
        href="https://medium.com/@shubhamprajapati7748"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-medium-m"></i>
      </a>

      <a
        href="https://stackoverflow.com/users/16515051/shubham-prajapati"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-arrow"></i>
      </a>

      <a
        href="https://www.reddit.com/user/Spare-Dot8539"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-reddit-alien-alt"></i>
      </a>
    </div>
  );
};

export default Social;
